import { Routes } from '@angular/router';

/** Lazy route tree for apps that mount onboarding without a local shell. */
export const ONBOARDING_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./onboarding/onboarding-home.component').then((m) => m.OnboardingHomeComponent),
  },
];
